<div class="d-flex justify-content-between align-items-center mb-4">
  <h2 class="m-0">
    {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
  </h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="table-container">
  <table
    *ngIf="data.product.originalSortimentEntries?.length; else emptyResponse"
    mat-table
    [dataSource]="dataSource"
    class="pricing-product-table"
  >
    <!-- Product name caption -->
    <ng-container matColumnDef="caption">
      <th mat-header-cell *matHeaderCellDef colspan="8" class="caption">
        {{ data.product.label }}
      </th>
    </ng-container>

    <!-- siteName Column -->
    <ng-container matColumnDef="siteName">
      <th mat-header-cell *matHeaderCellDef>
        {{ columnTitles["siteName"] | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong>{{ element.siteName }}</strong>
        <br />
        <span>{{ element.siteAddress }}</span>
      </td>
    </ng-container>

    <!-- Discount columns -->
    <ng-container matColumnDef="discount">
      <th mat-header-cell *matHeaderCellDef>
        {{ columnTitles["discount"] | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{ element.discountValue ?? 0 | number }}</span>
        <span>{{
          " " + ("VIP_DISCOUNTS." + element.discountMode | translate)
        }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef>
        {{ columnTitles["startDate"] | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{ element.startDate | date: "YYYY.MM.dd." }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef>
        {{ columnTitles["endDate"] | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{
          (element.endDate | date: "YYYY.MM.dd.") === cancellationMockDateHu
            ? ("VIP_DISCOUNTS.GIVEN.UNTIL_CANCELLATION" | translate)
            : (element.endDate | date: "YYYY.MM.dd.")
        }}</span>
      </td>
    </ng-container>

    <!-- Pricing columns -->
    <ng-container
      *ngFor="let column of priceColumns"
      matColumnDef="{{ column }}"
    >
      <th mat-header-cell *matHeaderCellDef>
        {{ columnTitles[column] | translate }}
        ({{ "NET_PRICE" | translate }})
      </th>
      <td mat-cell *matCellDef="let element" class="price-cell">
        <div
          *ngIf="
            element | originalPrice: column;
            else noPrice;
            let originalPrice
          "
          class="discount-price"
        >
          <span class="original-price"
            >{{ originalPrice | number }} {{ "CURR_SHORT" | translate }}</span
          >
          <span class="discount-price"
            >{{
              calculateDiscount(
                originalPrice,
                element.discountValue,
                element.discountMode
              ) | number
            }}
            {{ "CURR_SHORT" | translate }}</span
          >
        </div>
        <ng-template #noPrice>-</ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['caption']"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<ng-template #emptyResponse>
  <p>{{ "VIP_DISCOUNTS.GIVEN.NO_ORIGINAL_PRICE" | translate }}</p>
</ng-template>

<div class="d-flex justify-content-end mt-4">
  <button mat-button mat-stroked-button color="primary" mat-dialog-close>
    {{ "DIALOG.CLOSE" | translate }}
  </button>
</div>
